import React, { ReactNode } from 'react';

import { IconWithTitle } from '@shared/common/components/IconWithTitle';

import { WalletConnectType, WALLETS_CONFIG } from './model/walletsConfig';

type Props = {
  title: string;
  connectType: WalletConnectType;
  children: ReactNode;
};

export const WalletListItem = ({ title, connectType, children }: Props) => {
  const { Icon = null } = WALLETS_CONFIG[connectType] ?? {};

  return (
    <div className="flex justify-between items-center gap-2">
      <IconWithTitle icon={Icon ? <Icon /> : null} title={title} />
      <div className="flex gap-2">{children}</div>
    </div>
  );
};
